module.exports = __webpack_public_path__ + "static/media/lixa-dagua.4e835473.jpg";